<template>
  <el-dialog
    width="35%"
    class="dialog"
    :title="pageType === 'add' ? '创建合作方' : '编辑合作方'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"

    >
      <el-form-item label="合作方式：" prop="partnershipType">
        <el-radio-group v-model="formData.partnershipType">
          <el-radio
            v-for="item in orgTypeList"
            :key="item.code"
            :label="item.code"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="合作种类：" prop="cooperationTypes">
        <el-checkbox-group v-model="formData.cooperationTypes">
          <el-checkbox label="1">普通回收</el-checkbox>
          <el-checkbox label="2">以旧换新-支线物流</el-checkbox>
          <el-checkbox label="3">批量回收</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item
        v-if="formData.cooperationTypes.includes('1')"
        label="支付方式："
        prop="payType"
      >
        <el-radio-group v-model="formData.payType" disabled>
          <el-radio :label="1">线上支付</el-radio>
          <el-radio :label="0">线下支付</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="合作方名称：" prop="partnerName">
        <el-input v-model="formData.partnerName" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="合作方地址：" prop="address">
        <el-input v-model="formData.address" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系方式：" prop="contactInfo">
        <el-input
          v-model="formData.contactInfo"
          auto-complete="off"
          :maxlength="12"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属组织：" prop="org">
        <el-input v-model="formData.org" :maxLength="30"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    orgTypeList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      /**
       * pageType 弹框类型 add | edit
       * dialogFormVisible 弹框状态
       * formData 表单数据
       *    partnershipType 合作方式
       *    partnerName 合作方名称
       *    address 合作方地址
       *    contactInfo 联系方式
       * rules 表单规则
       */
      pageType: "add",
      dialogFormVisible: false,
      formData: {
        partnershipType: "",
        cooperationTypes: [], //合作种类 todo
        payType: 0, // 支付方式 1 线上支付 0 线下支付
        partnerName: "",
        address: "",
        contactInfo: "",
        org:'',//所属组织
      },
      rules: {
        partnershipType: [
          { required: true, message: "请选择合作方式", trigger: "blur" }
        ],
        cooperationTypes: [
          { required: true, message: "请选择合作种类", trigger: "change" }
        ],
        partnerName: [
          { required: true, message: "请填写合作方名称", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请填写合作方地址", trigger: "blur" }
        ],
        contactInfo: [
          { required: true, message: "请填写联系方式", trigger: "blur" },
          {
            pattern: /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/,
            message: "请输入正确的电话号码"
          }
        ],

      },
      btnLoading: false
    };
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    openDialog(pageType = "add", rowData) {
      this.resetFormStatus()
      this.pageType = pageType;
      if (pageType === "edit") {
        let url = `/autoapp-recovery-server-authapi/tbl-partner-management/getDetailByPartnershipId/${this.partnershipId}`;
        this.partnershipId = rowData.partnershipId;
        for (let item in this.formData) {
          this.formData[item] = rowData[item];
        }
        if (!this.formData.cooperationTypes) {
          this.formData.cooperationTypes = [];
        }
        if (this.formData.payType === undefined || this.formData.payType === null) {
          this.formData.payType = 0;
        }
      } else {
        this.partnershipId = "";
        this.formData.payType = 0;
      }
      this.dialogFormVisible = true
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const params = {
            partnershipId: this.partnershipId,
            ...this.formData
          }
          if (!this.formData.cooperationTypes.includes('1')) {
            delete params.payType;
          }
          this.saveFormDataReq(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 表单重置
    resetFormStatus () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    // 保存和编辑数据接口
    saveFormDataReq(params) {
      const url =
        "/autoapp-recovery-server-auth/api/tbl-partner-management/save";
      this.HttpService.post(url, params).then(res => {
        this.btnLoading = false;
        if (res.statusCode === 200) {
          const tipMsg = this.pageType === "add" ? "新增成功" : "修改成功";
          this.$message.success(tipMsg);
          this.dialogFormVisible = false;
          this.$emit("opera-success");
        } else {
          const msgTip = res.message || "请求出错";
          this.$message.error(msgTip);
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/AddOrEditOrg.vue